module.exports = __webpack_public_path__ + "img/22.16cda987.svg";